import { createResource, types } from '../../../utils/resource'
import orderBy from 'lodash/orderBy'
import get from 'lodash/get'
import groupBy from 'lodash/groupBy'
import reduce from 'lodash/reduce'

const userQuery = createResource('userQuery', {})

export default {
  ...userQuery,
  state() {
    return {
      ...userQuery.state,
      answers: {}
    }
  },
  actions: {
    ...userQuery.actions,
    clearAnswers ({commit}){
      commit('CLEAR_ANSWERS')
    }
  },
  mutations: {
    ...userQuery.mutations,
    [types.GET_ITEM.SUCCESS] (state, result) {
      state.items = [result.data]
      state.total = 1
      state.answers = reduce(result.data.answers, (acc, value) => {
        acc[value.question] = value.answer
        return acc
      }, state.answers)
      state.loading = false
    },
    ['CLEAR_ANSWERS']: state => {
      state.answers = {}
    }
  },
  getters: {
    ...userQuery.getters,
    getSortedItems: state => {
      return orderBy(state.items, ['completed'], ['asc'])
    },
    getQuestionsGropedByType: state => id => {
      const item = state.items.find(o => o._id === id)
      if (item) {
        const questions = get(item, 'query.questionnaireObj.questions')
        if (questions) {
          const answers = new Map(item.answers.map(({ question, answer }) => ([question, answer])))
          const trend = new Map(item.answers.map(({ question, trend }) => ([question, trend])))
          const alerts = new Map(item.answers.map(({ question, alertActive }) => ([question, alertActive])))
          questions.map(question => Object.assign(question, {answer: answers.get(question._id), trend: trend.get(question._id), alertActive: alerts.get(question._id)}))

          return groupBy(questions, 'type')
        }
      }
    },
    getQuestionsByQueryId: state => (queryId) => {
      const item = state.items.find(o => o._id === queryId)
      if (item) {
        return get(item, 'query.questions', [])
      }
      return []
    }
  }
}
